import {validationMessages} from 'aurelia-validation';
validationMessages['required'] = `\${$displayName} er påkrevd!`;
